export const GOVGR_CARD = "govgr-card";
export const GOVGR_CARD__BORDER = "govgr-card--border";
export const GOVGR_CARD__BORDER_GRAY = "govgr-card--border-gray";
export const GOVGR_CARD__HEADING = "govgr-card__heading";
export const GOVGR_CARD__ACTION = "govgr-card__action";
export const GOVGR_CARD__BODY = "govgr-card__body";
